export const HORIZONTAL_LINE_INDEXES = [2, 5, 13]
